import ChargebeeWidgetContainer from "../ChargebeeWidget";
import { ChargebeeWidgetForward } from "../ChargebeeWidget/ChargebeeWidget";

export default function OrganizationPaymentMethods() {
  return (
    <ChargebeeWidgetContainer forward={ChargebeeWidgetForward.PaymentMethods} />
  );
}
